import * as React from 'react';

import { useAtomValue, useSetAtom } from 'jotai';

import * as state from '../../_state/purchaseOrderDetails.state';

import { EntityTabNotes } from '~/shared/components/EntityTabNotes';

export const PurchaseOrderTabNotes = () => {
  const { data: purchaseOrder } = useAtomValue(state.$purchaseOrderDetails);

  const updatePurchaseOrder = useSetAtom(state.$updatePurchaseOrder);

  const handleSave = React.useCallback(
    (notes: { internalNotes: string; externalNotes: string }): void => {
      if (purchaseOrder?.id) {
        updatePurchaseOrder({
          id: purchaseOrder.id,
          ...notes,
        });
      }
    },
    [purchaseOrder?.id, updatePurchaseOrder],
  );

  return (
    <EntityTabNotes
      key={purchaseOrder?.id}
      counterparty="supplier"
      internalNotes={purchaseOrder?.customerInternalNotes}
      externalNotes={purchaseOrder?.customerExternalNotes}
      onSave={handleSave}
      className="@PurchaseOrderTabNotes"
    />
  );
};
